import dayjs from "dayjs";
import moment from "moment";
import config from "../config.json";

// import { AxiosErrorResponse, Scope } from "../Enum/utilsEnum";

//** Function to get AWS secret access key */
export const getS3SecretAccessKey = (value: string) => {
	const finalKey = value!.slice(6, 46);
	return finalKey;
};

//** Function to get Captcha secret key */
export const getCAPTCHASecretKey = (value: string) => {
	const finalKey = value!.slice(12, 52);
	return finalKey;
};

//** Function to get Captcha site key */
export const getCAPTCHASiteKey = (value: string) => {
	const finalKey = value!.slice(18, 58);
	return finalKey;
};

//** Function to get backend API  key */
export const getAPIKey = (value: string) => {
	const finalKey = value!.slice(9, 253);
	return finalKey;
};

/** Environment */
// Set below key and url accroding to your project
// export const API_KEY = import.meta.env.VITE_API_KEY;
// export const API_URL = import.meta.env.VITE_API_URL;

// For dev server set alias
export let API_URL: string;
export let BACKEND_DOMAIN: string;
export let API_KEY: string;
export let BUCKET_URL: string;
export let STORE_URL: string;
export let PROFILE_URL: string;
export let STATIC_PAGE_URL: string;
export let USER_SAMPLE_CSV: string;
export let INSERT_BASE_CSV: string;

export const API_VERSION = `v1`;

export let IS_DEV: number = config.env;
export let responseEncrypted = config?.isEncrypted;
export let secretKey = config?.encryptKey;

export const alias = IS_DEV === 1 ? "/soloatsea" : "";
export const appName = "SoloAtSea";
/** User Roles */
export const ROLE = {
	ADMIN: "admin",
	USER: "user",
	SUB_ADMIN: "sub-admin",
};

/** Client URL */
export let CLIENT_URL = IS_DEV ? "http://localhost:3000" + alias : "https://dev.3rddigital.com" + alias;

/** API URL */
switch (IS_DEV) {
	case 0:
		/** Client URL */
		CLIENT_URL = "http://localhost:3000" + alias;
		/** API URL */
		API_URL = `http://localhost:8107/api/${API_VERSION}`;
		STORE_URL = `http://localhost:8107/` + "public/common";
		BACKEND_DOMAIN = `http://localhost:8107`;
		API_KEY =
			"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoiYWRtaW4iLCJzZXJ2ZXJFbnYiOiJsb2NhbCIsImNyZWF0ZWRfYXQiOiIyMDI0LTEyLTIzVDEwOjMwOjAxLjI2OFoiLCJpYXQiOjE3MzQ5NDk4MDEsImF1ZCI6ImFkbWluIn0.uxsA1lcxQCejp5w3vYKUjdP1wNPG4NwFi-TZZg0w17Q";
		BUCKET_URL = "https://solo-at-sea-dev.s3.amazonaws.com/";
		PROFILE_URL = BUCKET_URL + "/profile";
		// STATIC_PAGE_URL = "http://localhost:3000/infinitywaste-web/";
		STATIC_PAGE_URL = "http://localhost:3000" + alias + "/";
		USER_SAMPLE_CSV = "http://localhost:8107/public/bulk-insert/userInsert.csv";
		INSERT_BASE_CSV = "http://localhost:8107/public/bulk-insert";
		break;
	case 1:
		/** Client URL */
		CLIENT_URL = "https://dev.3rddigital.com" + alias;
		API_URL = `https://dev.3rddigital.com/solo-at-sea-api/api/${API_VERSION}`;
		STORE_URL = `https://dev.3rddigital.com/solo-at-sea-api` + "/public/common";
		BACKEND_DOMAIN = `https://dev.3rddigital.com/solo-at-sea-api`;

		API_KEY =
			"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoiYWRtaW4iLCJzZXJ2ZXJFbnYiOiJkZXYiLCJjcmVhdGVkX2F0IjoiMjAyNC0xMi0xOVQxMDowNDo0Mi42MjJaIiwiaWF0IjoxNzM0NjAyNjgyLCJhdWQiOiJhZG1pbiJ9.SvWs93UzcOkPeu0C0d6NAwrxS8GGnuToyVrITC35tDU";
		BUCKET_URL = "https://solo-at-sea-dev.s3.amazonaws.com/";
		PROFILE_URL = BUCKET_URL + "/profile";
		// STATIC_PAGE_URL = "https://dev.3rddigital.com/infinitywaste-web/";
		STATIC_PAGE_URL = "https://dev.3rddigital.com" + alias + "/";
		USER_SAMPLE_CSV = "https://dev.3rddigital.com/solo-at-sea-api/public/bulk-insert/userInsert.csv";
		INSERT_BASE_CSV = "https://dev.3rddigital.com/solo-at-sea-api/public/bulk-insert";
		break;
	case 2:
		/** Client URL */
		CLIENT_URL = "https://soloatsea.com" + alias;

		API_URL = `https://soloatsea.com/api/${API_VERSION}`;
		STORE_URL = `https://soloatsea.com/api/` + "/public/common";
		BACKEND_DOMAIN = `https://soloatsea.com/api`;

		API_KEY =
			"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoiYWRtaW4iLCJzZXJ2ZXJFbnYiOiJwcm9kIiwiY3JlYXRlZF9hdCI6IjIwMjUtMDEtMjBUMTQ6MDY6NTQuNzU1WiIsImlhdCI6MTczNzM4MjAxNCwiYXVkIjoiYWRtaW4ifQ.dZYmYSPO4kMgLeYlnhBogWJ69znK7l5SFlUFocdy1fI";
		BUCKET_URL = "https://s3.us-east-1.amazonaws.com/solo-at-sea-live/";
		PROFILE_URL = BUCKET_URL + "/profile";
		// STATIC_PAGE_URL = "https://dev.3rddigital.com/infinitywaste-web/";
		STATIC_PAGE_URL = "https://soloatsea.com" + alias + "/";
		USER_SAMPLE_CSV = "https://soloatsea.com/api/public/bulk-insert/userInsert.csv";
		INSERT_BASE_CSV = "https://soloatsea.com/api/public/bulk-insert";

		break;

	default:
}

/** Common Variables */
//  export const EMAIL_REGEX = /^[\w+-.]+@([\w-]+\.)+[\w-]{2,4}$/g;
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const PHONE_REGEX = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
export const ONLY_NUMBERS_REGEX = /^[0-9]+$/;
export const ONLY_ALPHABETS_REGEX = /^[A-Za-z ]+$/;
export const allowedExtensions = ["pdf", "jpeg", "jpg", "png", "gif", "bmp", "ico", "svg", "heif", "apng", "avif", "webp", "tiff"];
export const ONE_DAY_IN_MS = 24 * 60 * 60 * 1000;

/** Date Functions Starts */
export const dayjsFormat = "YYYY-MM-DD";
export const dayjsFormatTime = "YYYY-MM-DD hh:mm A";
export const lifetimeDate = new Date(dayjs("01-01-2024").format(dayjsFormat));
const day = new Date(dayjs("01-01-2024").format(dayjsFormat)).getDate();
const month = new Date(dayjs("01-01-2024").format(dayjsFormat)).getMonth() + 1;
const year = new Date(dayjs("01-01-2024").format(dayjsFormat)).getFullYear();
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const momentDDMMYY = (data: any) => moment(data).format(dayjsFormat);
export const momentDateTime = (data: moment.MomentInput) => moment(data).format(dayjsFormatTime);
export const lifetimeDateWithFormat = `${year}-${month < 9 ? `0${month}` : month}-${day < 9 ? `0${day}` : day}`;

export const rightsReserved = "© 2024 SoloAtSea LLC. All rights reserved.";
